import { initialState } from './initialState';
import { appendPage, createReducer, dataAs, pagedRequestCases, requestCases } from './requestState';

// The received-prize list keeps a full flag set of its own, so it can run next to the other reward
// requests. The points redemption has only its own loading flag: its success and error are the
// shared `success` / `error` the other requests write.
const RECEIVED_PRIZE_FLAGS = { loading: 'isLoadingReward', success: 'successReward', error: 'errorReward' };
const REDEEM_PTS_FLAGS = { loading: 'isRedeemPtsLoading', success: 'success', error: 'error' };

export default createReducer(initialState, {
  ...pagedRequestCases('FINISHED_SURVEY', 'finishedSurveyRequestIds', {
    success: appendPage('finished_survay', 'totalFinishedSurveys'),
  }),
  RESET_FINISHED_SURVEY: state => ({
    ...state,
    finished_survay: [],
    totalFinishedSurveys: null,
    finishedSurveyRequestIds: [],
  }),

  ...pagedRequestCases('RECIVED_PRIZE', 'receivedPrizeRequestIds', {
    flags: RECEIVED_PRIZE_FLAGS,
    success: appendPage('recived_prize_data', 'totalReceivedPrize'),
  }),
  RESET_RECIVED_PRIZE: state => ({
    ...state,
    recived_prize_data: [],
    totalReceivedPrize: null,
    receivedPrizeRequestIds: [],
  }),

  ...requestCases('GET_PAYMENT', { success: dataAs('get_payment_data') }),
  ...requestCases('GET_PAYMENT_PTS', { success: dataAs('get_payment_pts_data') }),
  ...requestCases('GET_PAYMENT_DETAIL', { success: dataAs('payment_detail') }),
  ...requestCases('UPDATE_PROFILES', { success: dataAs('update_profile_detail') }),
  ...requestCases('SMS_SEND', { success: dataAs('sms_send_detail') }),
  ...requestCases('REDEEME_REQUEST', { success: dataAs('redeem_request_detail') }),
  ...requestCases('REDEEME_PTS_REQUEST', { flags: REDEEM_PTS_FLAGS, success: dataAs('redeem_pts_request_detail') }),
});
